import { APP_INITIALIZER, ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core'
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GuestModule } from './component/guest/guest.module';
import { SharedService } from './services/shared.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './component/user/user.component';
import { UserModule } from './component/user/user.module';
import * as Sentry from "@sentry/angular";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
import { SharedModule } from './shared.module';
import { ServiceWorkerModule } from '@angular/service-worker'; // Import the shared module
import { Router } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    UserComponent,
    // PaginationComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CommonModule,
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      defaultLanguage: 'vi',
      isolate: true,
    }),
    GuestModule,
    UserModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    SharedService,
    provideHttpClient(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
